export default __webpack_public_path__ + "static/media/bell.19a68319.svg";